import React, { createContext, useContext, useState } from 'react';
import { CheckboxesOptions } from '../../../../../../components/checkbox-select';
import {
  AggregateVectorParameterTypeInternal,
  PeriodWeeklyPeriod,
} from '../../../../../../data-access/gql-types/graphql';
import { ChildrenProps } from '../../../../../../types/common';
import { MeasurementRange } from '../../../../../../types/measurement';
import { MeterDetailsState } from '../analysis/types';
import { ComparatorTariff } from '../comparator/types/types';

const initialState: MeterDetailsState = {
  currentParameterIndex: 0,
  setCurrentParameterIndex: () => null,
  currentPhases: [],
  setCurrentPhases: () => null,
  measurementsPhaseIndex: 0,
  setMeasurementsPhaseIndex: () => null,
  activePeriod: PeriodWeeklyPeriod.Total,
  setActivePeriod: () => null,
  aggregatedParameters: [],
  setAggregatedParameters: () => null,
  activeMeasurementRange: MeasurementRange.DayInHours,
  setActiveMeasurementRange: () => null,
  analysisPhases: [0],
  setAnalysisPhases: () => null,
  comparatorTariffs: [{ operator: '', tariff: '' }],
  setComparatorTariffs: () => null,
  comparatorPage: 0,
  setComparatorPage: () => null,
  comparatorParam: AggregateVectorParameterTypeInternal.Price,
  setComparatorParam: () => null,
};

export const MeterDetailsContext = createContext(initialState);

export const useMeterDetailsContext = (): MeterDetailsState => useContext(MeterDetailsContext);

const MeterDetailsProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [currentParameterIndex, setCurrentParameterIndex] = useState<number>(initialState.currentParameterIndex);
  const [currentPhases, setCurrentPhases] = useState<number[]>(initialState.currentPhases);
  const [measurementsPhaseIndex, setMeasurementsPhaseIndex] = useState<number>(initialState.measurementsPhaseIndex);
  const [activePeriod, setActivePeriod] = useState<PeriodWeeklyPeriod>(initialState.activePeriod);
  const [aggregatedParameters, setAggregatedParameters] = useState<
    CheckboxesOptions<AggregateVectorParameterTypeInternal>[]
  >(initialState.aggregatedParameters);
  const [activeMeasurementRange, setActiveMeasurementRange] = useState<MeasurementRange>(
    initialState.activeMeasurementRange,
  );
  const [analysisPhases, setAnalysisPhases] = useState<number[]>(initialState.analysisPhases);
  const [comparatorTariffs, setComparatorTariffs] = useState<ComparatorTariff[]>(initialState.comparatorTariffs);
  const [comparatorPage, setComparatorPage] = useState<number>(initialState.comparatorPage);
  const [comparatorParam, setComparatorParam] = useState<AggregateVectorParameterTypeInternal>(
    initialState.comparatorParam,
  );

  const values: MeterDetailsState = {
    currentParameterIndex,
    setCurrentParameterIndex,
    currentPhases,
    setCurrentPhases,
    measurementsPhaseIndex,
    setMeasurementsPhaseIndex,
    activePeriod,
    setActivePeriod,
    aggregatedParameters,
    setAggregatedParameters,
    activeMeasurementRange,
    setActiveMeasurementRange,
    analysisPhases,
    setAnalysisPhases,
    comparatorTariffs,
    setComparatorTariffs,
    comparatorPage,
    setComparatorPage,
    comparatorParam,
    setComparatorParam,
  };

  return <MeterDetailsContext.Provider value={values}>{children}</MeterDetailsContext.Provider>;
};

export default MeterDetailsProvider;
